/**
 * CategoryListItem
 * @module components/CategoryListItem
 */

import clsx from 'clsx';
import Icon from 'components/ui/Icon';
import { MouseEventHandler } from 'react';

interface Props {
	/** Pass an optional className */
	className?: string;

	/** Link text */
	text: string;

	/** Link url */
	url: string;

	/** Link target */
	target?: string;

	/** Pass an optional onClick Function */
	onClick?: MouseEventHandler;
}

const CategoryListItem = ({
	className,
	text,
	url,
	target,
	onClick = () => {},
}: Props): JSX.Element => {
	return (
		<li className={clsx(className)}>
			<a
				href={url}
				target={target}
				onClick={(e) => onClick(e)}
				className="text-blue flex items-center text-p hover:underline"
			>
				<Icon icon="arrow" aria-hidden={true} direction="right" size={1} />
				<span className="ml-1">{text}</span>
			</a>
		</li>
	);
};

export default CategoryListItem;
